export default __webpack_public_path__ + "static/7-bdf86a032edd6ee10150459f9e446205.jpg";